import { Trans, useTranslation } from '@frontend/i18n';
import { usePhoneSettingsShallowStore } from '@frontend/phone-config';
import { DropdownField, FormRow, Text } from '@frontend/design-system';
import { CreateSoftphonePropTypes, inputFieldStyles } from '..';

export const LocationSetupStep = ({ getFieldProps, values }: CreateSoftphonePropTypes) => {
  const { t } = useTranslation('phone', { keyPrefix: 'create-new-softphone' });

  const { settingsTenantLocation } = usePhoneSettingsShallowStore('settingsTenantLocation');
  const locations = settingsTenantLocation?.children;

  return (
    <>
      <Text>
        <Trans t={t}>
          Assign a primary location for this Softphone. This will set the location of the park slots and hold music for
          the device. <b>{values?.firstName}</b> can still manage calls for all locations within the organization using
          this device.
        </Trans>
      </Text>
      <FormRow css={inputFieldStyles}>
        <DropdownField {...getFieldProps('childLocationSelectedId')} label=''>
          {!!locations?.length &&
            locations.map((location) => {
              return (
                <DropdownField.Option key={location.id} value={location.id}>
                  {location.name}
                </DropdownField.Option>
              );
            })}
        </DropdownField>
      </FormRow>
    </>
  );
};
